<template>
  <div class="prototype-page">
    <div class="app-shell">
      <header class="page-header">
        <div class="header-inner">
          <div class="logo">
            <div class="logo-badge">3P</div>
            <span class="site-title">3P影视</span>
          </div>
          <div class="domain-display">
            <div class="domain-slider">
              <span v-for="(domain, idx) in domains" :key="idx" class="domain-item">{{ domain }}</span>
            </div>
          </div>
          <div class="header-action" @click="goBcak">返回</div>
        </div>
        <!-- <div class="search-bar-container">
          <div class="search-bar">搜索视频 / 分类 / 主播</div>
        </div> -->
      </header>

      <section class="hero-player" @click="handlePlayClick">
        <div id="msed" class="hero-player__container"></div>
        <img v-if="!playerReady" :src="detailCover" :alt="detail.title || currentVideo.title">
        <div v-if="!playerReady" class="play-badge">▶</div>
      </section>

      <section class="info-card">
        <h1 class="detail-title">{{ detail.title || currentVideo.title }}</h1>
        <div class="muted-text">{{ detailMeta }}</div>
        <div class="inline-tip" style="margin-top: 14px;">建议收藏本站，避免下次找不到入口。</div>
        <div class="action-row" style="margin-top: 14px;">
          <div class="btn" @click="copyLink">复制链接</div>
          <router-link class="ghost-btn" to="/">返回首页</router-link>
          <router-link class="ghost-btn" to="/list">更多视频</router-link>
        </div>
        <div class="helper-text" :class="feedbackClass" style="margin-top: 12px;">
          {{ feedbackText }}
        </div>
      </section>

      <section class="section">
        <div class="section-title">
          <h2>详情广告位</h2>
        
        </div>
      </section>
      <div class="stack-list">
        <router-link
          v-for="(ad, index) in detailAds"
          :key="ad.id"
          class="home-reference-banner"
          :style="adStyle(index + 12)"
          :to="ad.url || `/detail?id=${(ad.id % videos.length) + 1}`"
        >
          <span class="home-reference-banner__text">
            <em :style="{ color: adTagColor(index + 12) }">【{{ ad.title.split(' ')[0] || '推荐' }}】</em>
            <strong>{{ ad.title }}</strong>
          </span>
          <span class="home-reference-banner__arrow">›</span>
        </router-link>
      </div>

      <section class="section">
        <div class="section-title">
          <h2>相关推荐</h2>
        </div>
        <div class="grid video-grid">
          <router-link
            v-for="(video, index) in recommendVideos"
            :key="`${video.id || video.vid || video.number || 'rv'}-${index}`"
            class="video-card"
            :to="`/detail?id=${video.id || video.vid}`"
          >
            <div class="video-cover">
              <!-- <span class="video-badge" v-if="video.is_free == 1" style="background: green;">免费</span>
              <span class="video-badge" v-else-if="video.is_free == 0" style="background: red;">付费</span>
              <span class="video-badge" v-else>{{ video.badge }}</span> -->
              <img :src="video.thumb_image || getCoverUrl(video)" :alt="video.title">
              <span class="video-duration">{{ video.times || video.duration }}</span>
            </div>
            <div class="video-body">
              <p class="video-title">{{ video.title }}</p>
              <div class="meta-row">
                <span>{{ video.day || video.publishTime }}</span>
                <span>{{ video.rand ? `已有${video.rand}人看过` : `${video.hotValue} 热度` }}</span>
              </div>
            </div>
          </router-link>
        </div>
      </section>
    </div>

    <!-- <ShareModal v-if="showShareModal" @success="handleShareSuccess" @close="handleShareClose" /> -->
  </div>
</template>

<script>
import ShareModal from "./ShareModal.vue";
import { copyCurrentLink, decryptApiPayload, getBannerUrl, getCachedNavUrlList, getCoverUrl, getDetailId } from "@/prototype/render-helpers";
import { siteData } from "@/prototype/site-data";
import { dv6Api, vlv6Api, getAdsListApi } from "@/api/api";
import CryptoJS from "crypto-js";
import bplayer from "@/utils/bplayer";

export default {
  name: "DetailPage",
  components: {
    ShareModal,
  },
  data() {
    return {
      apiAds: [],
      domains: getCachedNavUrlList(),
      siteData,
      feedbackText: "播放器区域为静态演示，可后续接真实视频地址。",
      feedbackType: "",
      showShareModal: true,
      hasShared: false,
      playerReady: false,
      tryPayPlayer: null,
      detail: {
        id: 0,
        title: "",
        thumb_image: "",
        cate_id: 0,
        day: "",
        rand: "",
        times: "",
        try_see: 0,
        link: "",
      },
      recommendList: [],
      params: {
        ldk: "",
        uid: "",
        page: 1,
        limit: 6,
        cate_id: 0,
        key: "",
        payed: 0,
        templete_id: 1,
        webmanage: 0,
      },
    };
  },
  computed: {
    videos() {
      return this.siteData.videos;
    },
    currentVideo() {
      const id = getDetailId(this.$route);
      return this.siteData.videos.find((item) => item.id === id) || this.siteData.videos[0];
    },
    detailCover() {
      return this.detail.thumb_image || getCoverUrl(this.currentVideo);
    },
    detailMeta() {
      const parts = [
        this.detail.day || this.currentVideo.publishTime,
        this.detail.rand ? `已有${this.detail.rand}人看过` : `${this.currentVideo.hotValue} 热度`,
        this.detail.cate_name || this.currentVideo.category,
        this.detail.times || this.currentVideo.duration,
      ];
      return parts.filter(Boolean).join(" | ");
    },
    detailAds() {
      const source = this.apiAds.length ? this.apiAds : this.siteData.ads;
      return source.filter((item) => item.position == 5).slice(0, 5);
    },
    recommendVideos() {
      if (this.recommendList.length > 0) {
        return this.recommendList;
      }
      return this.siteData.videos.filter((item) => item.id !== this.currentVideo.id).slice(0, 6);
    },
    feedbackClass() {
      if (this.feedbackType === "success") return "success-text";
      if (this.feedbackType === "error") return "error-text";
      return "";
    },
  },
  mounted() {
    this.bootstrapDetailData();
    this.fetchAds();
  },
  beforeDestroy() {
    this.destroyDetailPlayer();
  },
  watch: {
    "$route.query.id"() {
      this.destroyDetailPlayer();
      this.playerReady = false;
      this.hasShared = false;
      this.showShareModal = true;
      this.bootstrapDetailData();
    },
  },
  methods: {
    goBcak() {
    const ldk =
      this.$route.query.ldk ||
      localStorage.getItem("ldk") ||
      "";

    // ✅ 有历史记录就返回
    if (window.history.length > 1) {
      this.$router.back();
      return;
    }

    // ❗ 没历史记录（比如从外部打开）
    this.$router.replace({
      path: "/",
      query: ldk ? { ldk } : {},
    });
  },
    async fetchAds() {
      try {
        const res = await getAdsListApi({ limit: 100 });
        const list = decryptApiPayload(res, this.$decryptData);
        if (Array.isArray(list)) {
          this.apiAds = list;
        }
      } catch (error) {
        console.error("Failed to fetch ads", error);
      }
    },
    getBannerUrl,
    getCoverUrl,
    bootstrapLegacyDeps() {
      if (!CryptoJS || !bplayer) {
        console.warn("Legacy deps unavailable");
      }
    },
    resolveLandingKey() {
      const routeLdk = this.$route && this.$route.query ? this.$route.query.ldk : "";
      const localLdk = window.localStorage.getItem("ldk") || "";
      const ldk = routeLdk || localLdk || "";
      if (ldk) {
        window.localStorage.setItem("ldk", ldk);
      }
      return ldk;
    },
    decryptPayload(payload) {
      try {
        const decryptedText = this.$decryptData(payload);
        return decryptedText ? JSON.parse(decryptedText) : null;
      } catch (error) {
        console.error("Failed to decrypt detail payload", error);
        return null;
      }
    },
    async bootstrapDetailData() {
      this.bootstrapLegacyDeps();
      this.params.ldk = this.resolveLandingKey();
      this.params.uid = window.localStorage.getItem("visitorId") || "";
      await this.fetchDetail();
      await this.fetchRecommendVideos();
    },
    async fetchDetail() {
      try {
        const res = await dv6Api({
          ldk: this.params.ldk,
          uid: this.params.uid,
          vid: getDetailId(this.$route),
        });
        const temp = this.decryptPayload(res);
        if (temp && temp.detail) {
          this.detail = {
            ...this.detail,
            ...temp.detail,
            id: temp.detail.id || temp.detail.vid || getDetailId(this.$route),
          };
          this.feedbackText = temp.pay != 1 ? "当前视频尚未支付，需先完成分享或购买后观看。" : "播放器区域为静态演示，可后续接真实视频地址。";
          if (this.hasShared && this.detail.link) {
            this.createDetailPlayer(this.detail);
          }
        }
      } catch (error) {
        console.error("Failed to fetch detail", error);
      }
    },
    async fetchRecommendVideos() {
      try {
        const res = await vlv6Api({
          ...this.params,
          cate_id: this.detail.cate_id || this.params.cate_id || 0,
          sp: window.localStorage.getItem("sp"),
          ua: window.localStorage.getItem("parent"),
        });
        const temp = this.decryptPayload(res);
        if (temp && Array.isArray(temp.data)) {
          const currentId = this.detail.id || getDetailId(this.$route);
          this.recommendList = temp.data.filter((item) => (item.id || item.vid) !== currentId).slice(0, 6);
        }
      } catch (error) {
        console.error("Failed to fetch recommend videos", error);
      }
    },
    adStyle(index) {
      const palette = this.siteData.adPalette[index % this.siteData.adPalette.length];
      return {
        background: palette.bg,
        color: palette.text,
      };
    },
    adTagColor(index) {
      return this.siteData.adPalette[index % this.siteData.adPalette.length].tag;
    },
    destroyDetailPlayer() {
      if (this.tryPayPlayer) {
        try {
          this.tryPayPlayer.pause();
          this.tryPayPlayer.destroy();
        } catch (error) {
          console.error("Failed to destroy player", error);
        }
        this.tryPayPlayer = null;
      }
    },
    createDetailPlayer(videoInfo) {
      const Player = window.Player;
      if (!Player || !videoInfo || !videoInfo.link) {
        this.feedbackType = "error";
        this.feedbackText = "当前视频暂无可播放地址。";
        return;
      }

      this.destroyDetailPlayer();
      this.playerReady = false;

      this.$nextTick(() => {
        this.tryPayPlayer = new Player({
          id: "msed",
          url: videoInfo.link,
          playsinline: true,
          "x5-video-player-fullscreen": "false",
          "x5-video-orientation": "portraint",
          "x5-video-player-type": "h5",
          fluid: true,
          closeVideoClick: true,
          closeVideoDblclick: true,
          closeVideoTouch: true,
          closePlayerBlur: true,
          closeControlsBlur: true,
          closeFocusVideoFocus: true,
          closePlayVideoFocus: true,
          enableContextmenu: true,
        });

        const playerElement = document.getElementById("msed");
        if (playerElement) {
          playerElement.addEventListener("click", (e) => {
            e.stopPropagation();
          });
          playerElement.addEventListener("touchend", (e) => {
            e.stopPropagation();
          });
        }

        this.tryPayPlayer.start();
        this.playerReady = true;
      });
    },
    async copyLink() {
      try {
        await copyCurrentLink();
        this.feedbackType = "success";
        this.feedbackText = "链接已复制，请尽快保存到浏览器收藏夹或备忘录。";
      } catch (error) {
        this.feedbackType = "error";
        this.feedbackText = "当前环境未能自动复制，请手动复制地址栏链接。";
      }
    },
    handlePlayClick() {
      
        this.feedbackType = "success";
        this.feedbackText = "正在加载播放器资源...";
        this.createDetailPlayer(this.detail);
      
    },
    handleShareSuccess() {
      this.hasShared = true;
      this.showShareModal = false;
      this.feedbackType = "success";
      this.feedbackText = "验证成功！您现在可以免费观看完整视频了。";
      this.createDetailPlayer(this.detail);
    },
    handleShareClose() {
      this.showShareModal = false;
    },
  },
};
</script>
